export default __webpack_public_path__ + "static/media/4WF.6fb708f5.png";